













































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';

//@ts-ignore
import store from "../../store";
import UploadHelper from "../../helpers/UploadHelper";
import {
    CurrentGame, GameAutomation,
    GameSettings, Player,
    UploadFieldBackgroundResponse
} from "../../../types";
import MessageHelper from "../../helpers/MessageHelper";
import EventApi from "../../api/EventsApi";
import PixiScene from "../../libs/table-hand/api/render/PixiScene";
import {NewPixiScene} from "../../libs/table-hand/pixi/NewPixiScene";
import Loader from "../Widgets/Loader.vue";
import TimesOfDay from "../Automations/Mafia/TimesOfDay.vue";
import AutomationCodes from "../../../enums/automation-codes/AutomationCodes";
import PixiPainter from "../../libs/table-hand/api/render/PixiPainter";
import TasksStateTypesEnums from "../../../enums/tasks-state-types/TasksStateTypesEnums";
import SimiloInformer from "../Automations/Similo/SimiloInformer.vue";
import MessageInformer from "../Informers/MessageInformer.vue";
import ToolsPanel from "../ToolsPanel/Panel/ToolsPanel.vue";
import DiceGeneratorNew from "../ToolsPanel/Dice/DiceGeneratorNew.vue";
import ToolsTimer from "../ToolsPanel/Timer/ToolsTimer.vue";
import ToolsNotes from "../ToolsPanel/Notes/ToolsNotes.vue";
import {Tool} from "../../helpers/Tool";
import {LayoutTypes} from "../../../enums/layout-types/LayoutTypes";

@Component({
    components: {
        ToolsNotes,
        ToolsTimer,
        DiceGeneratorNew,
        ToolsPanel,
        MessageInformer,
        SimiloInformer,
        TimesOfDay,
        Loader

    },
})

export default class GameTable extends Vue {
    @Prop({required: true}) private readonly layoutType!: string;
    @Prop({required: true}) private readonly uploadCardsUrl!: string;
    @Prop({required: true}) private readonly uploadBackgroundUrl!: string;
    @Prop({required: true}) private readonly currentPlayerColor!: string;
    @Prop({required: true}) private readonly formIsVisible!: boolean;
    @Prop({default: false}) private readonly isProfileEditor!: boolean;

    private loading: boolean = true;
    private mouseEventsAreAllowed: boolean = true;
    private startTableZoomValue: number|null = null;
    private currentTableZoomValue: number = 1;
    private files: FileList|null = null;
    private showTableForm: boolean = false;
    private isOldTable: boolean = true;
    private handIsOpened: boolean = true;
    private pixiScene: PixiScene|undefined = undefined;
    private newPixiScene: NewPixiScene|undefined = undefined;
    private uploadFormType: string = '';
    private isBackgroundPattern: boolean = false;
    private isAdminGridVisible: boolean = true;
    private patternType: number = 1;
    private automationsAreVisible: boolean = false;
    private patterns: Array<{[key: string]: string|number}> = [
        {'value': 1, 'name': 'repeat'}, //TODO: изменить значения value на константы
        {'value': 2, 'name': 'no-repeat'},
        {'value': 3, 'name': 'repeat-x'},
        {'value': 4, 'name': 'repeat-y'},
    ];

    private diceGeneratorIsVisible: boolean = false;
    private timerIsVisible: boolean = false;
    private noteIsVisible: boolean = false;
    private diceCoordinates: null|{x: number, y: number} = null;
    private timerCoordinates: null|{x: number, y: number} = null;
    private noteCoordinates: null|{x: number, y: number} = null;

    mounted(): void
    {
        const timer = setInterval(() => {
            if (this.fieldState) {
                clearInterval(timer);
                this.createPixiTable();

                //Убрать после рефактора сцены
                if (this.pixiScene) {
                    this.handIsOpened = this.playerHandVisibility;
                    this.pixiScene.toggleHand(this.handIsOpened);
                    this.pixiScene.updatePlayerColor();
                    if (this.pixiScene.isLoaded) {
                        this.hideLoader();
                    }
                }
                if (this.newPixiScene) {
                    this.handIsOpened = this.playerHandVisibility;
                    this.newPixiScene.toggleHand(this.handIsOpened);
                    this.newPixiScene.updatePlayerColor();
                    if (this.newPixiScene.loaded) {
                        this.hideLoader();
                    }
                }
            }
        }, 100);

        document.addEventListener('contextmenu', e => {
           if ((e.target as HTMLElement).tagName.toLowerCase() === 'canvas') {
               e.preventDefault();
           }
        });

        EventApi.addEventListener(EventApi.TABLE_IS_LOADED, this.hideLoader);
        EventApi.addEventListener(EventApi.SHOW_TABLE_LOADER, this.showLoader);
        EventApi.addEventListener(EventApi.TABLE_DRAG_STARTED, this.disableLayoutInteractions);
        EventApi.addEventListener(EventApi.TABLE_DRAG_ENDED, this.enableLayoutInteractions);
        EventApi.addEventListener(EventApi.CLOSE_AUTOMATIONS, this.closeAutomations);
        EventApi.addEventListener(EventApi.CHANGE_HAND_VISIBILITY, this.changeHandVisibilityWithMessage);
    }

    beforeDestroy(): void
    {
        EventApi.removeEventListener(EventApi.TABLE_IS_LOADED, this.hideLoader);
        EventApi.removeEventListener(EventApi.SHOW_TABLE_LOADER, this.showLoader);
        EventApi.removeEventListener(EventApi.TABLE_DRAG_STARTED, this.disableLayoutInteractions);
        EventApi.removeEventListener(EventApi.TABLE_DRAG_ENDED, this.enableLayoutInteractions);
        EventApi.removeEventListener(EventApi.CLOSE_AUTOMATIONS, this.closeAutomations);
        EventApi.removeEventListener(EventApi.CHANGE_HAND_VISIBILITY, this.changeHandVisibilityWithMessage);
    }

    /**
     * Watch поля
     */
    @Watch('fieldState')
    gameFieldChanged(newVal: any, oldVal: any) {
        if (newVal) {
            this.isBackgroundPattern = !!newVal.background.pattern;
        }
    }

    /**
     * Watch поля
     */
    @Watch('playerHandVisibility')
    playerHandVisibilityChanged(newVal: boolean, oldVal: boolean) {
        //Убрать после рефактора сцены
        if (this.pixiScene) {
            this.handIsOpened = newVal;
            this.pixiScene.toggleHand(this.handIsOpened);
            this.pixiScene.resizeHandler(true);
        }
        if (this.newPixiScene) {
            this.handIsOpened = newVal;
            this.newPixiScene.toggleHand(this.handIsOpened);
            //EventApi.triggerEvent(EventApi.SHOW_TABLE_LOADER, {stage: this});
        }
    }

    /**
     * Watch статуса гостя
     */
    @Watch('isGuest')
    watchGuestStatus(newVal: boolean, oldVal: boolean) {
        //Убрать после рефактора сцены
        if (this.pixiScene) {
            this.pixiScene.setGuestStatus(newVal);
        }
        this.newPixiScene && (this.newPixiScene.guest = newVal);
    }

    @Watch('currentPlayerColor')
    changeCurrentPlayerColor(newVal: string, oldVal: string) {
        if (newVal !== oldVal) {
            //Убрать после рефактора сцены
            this.pixiScene?.tableBorderColor(newVal);

            this.newPixiScene && (this.newPixiScene.borderColor = newVal);
        }
    }

    /**
     * Отслеживаем изменения списка игроков
     * @param newVal
     * @param oldVal
     */
    @Watch('players')
    changePlayersData(newVal: Array<Player>, oldVal: Array<Player>) {
        if (!Tool.objectsEqual(newVal, oldVal) && this.newPixiScene) {
            this.newPixiScene.updatePlayers(newVal);
        }
    }

    @Watch('loading')
    changeLoading(newVal: boolean, oldVal: boolean)
    {
        console.log({
            new: newVal,
            old: oldVal
        })
    }

    /**
     * Состояние игрового поля
     */
    private get fieldState(): any
    {
        return store.getters.getGameField;
    }

    /**
     * Лейайт с ситами на столе
     * @private
     */
    private get isSeatOnTableLayout(): boolean
    {
        return this.layoutType === LayoutTypes.LAYOUT_SEAT_ON_TABLE;
    }

    /**
     * ID игрока
     */
    private get playerId(): string
    {
        return store.getters.getPlayerId;
    }

    /**
     * Список игроков
     * @private
     */
    private get players(): Array<Player>
    {
        return store.getters.getPlayers;
    }

    /**
     * Видимость руки
     * @private
     */
    private get playerHandVisibility(): boolean
    {
        if (!this.fieldState || this.isProfileEditor) {
            return true;
        }
        if (!this.fieldState.players[this.playerId]) {
            return false;
        }
        return this.fieldState.players[this.playerId].visible;
    }

    /**
     * Начата ли игра
     */
    private get gameIsStarted(): boolean
    {
        if (typeof this.gameState === 'undefined' || typeof this.gameState.tasks === 'undefined') {
            return false;
        }
        return this.gameState.tasks.state.game_started;
    }

    /**
     * Текущая игра
     * @private
     */
    private get currentGame(): CurrentGame|null
    {
        return store.getters.getCurrentActivity;
    }

    /**
     * Видна ли рука
     */
    private get handIsVisible(): boolean
    {
        if (typeof this.gameState === 'undefined' || typeof this.gameState.tasks === 'undefined') {
            return false;
        }
        const state = this.gameState.tasks.state;
        if (state.type === 2 || state.zone_type === 2) {
            return true;
        }
        return false;
    }

    /**
     * Состояние игрового поля
     */
    private get gameState(): any
    {
        return store.getters.getGameState;
    }

    /**
     * Настройки текущей игры
     */
    private get currentGameSettings(): GameSettings|null
    {
        if (!this.currentGame) {
            return null;
        }
        return this.currentGame.settings;
    }

    /**
     * Можно ли добавлять картинки на стол/в руку
     */
    private get tableIsManageable(): boolean
    {
        if (!this.currentGameSettings) {
            return true;
        }
        return this.currentGameSettings.canManageHandtable;
    }

    /**
     * Запущена игра "Мафия"
     * @private
     */
    private get isMafia(): boolean
    {
        return this.currentGame?.automation_code === AutomationCodes.MAFIA;
    }

    /**
     * Статус подключения игрока (guest, active, pending)
     */
    private get playerConnectionStatus(): string
    {
        return store.getters.getPlayerConnectionStatus;
    }

    /**
     * Является гостем
     */
    private get isGuest(): boolean
    {
        return this.playerConnectionStatus === 'guest';
    }

    /** Статус подключения: активный игрок на сите */
    private get isActive(): boolean
    {
        return this.playerConnectionStatus === 'active';
    }

    /**
     * Показать лого по центру стола
     */
    private get showLogo(): boolean
    {
        return this.fieldState.showLogo;
    }

    private get gameAutomation(): GameAutomation|null
    {
        return this.gameState.automation;
    }

    /**
     * Показывать кнопку следующего раунда
     * @private
     */
    private get showNextRoundButton(): boolean
    {
        const automationCodes: Array<string> = [
            AutomationCodes.DETECTIVE_CLUB,
            AutomationCodes.SIMILO
        ];

        return !!this.gameAutomation
            && this.gameAutomation.tasksContainer.nextTaskButton.enabled
            && !!this.currentGame
            && !!this.currentGame.automation_code
            && automationCodes.includes(this.currentGame.automation_code);
    }

    /**
     * Показывать информер симилио
     * @private
     */
    private get showSimiloInformer(): boolean
    {
        const automationCodes: Array<string> = [
            AutomationCodes.SIMILO
        ];

        return !!this.gameAutomation
            && !!this.currentGame
            && !!this.currentGame.automation_code
            && automationCodes.includes(this.currentGame.automation_code);
    }

    /**
     * Start new game btn is visible
     * @private
     */
    private get showRestartGameButton(): boolean
    {
        const automationCodes: Array<string> = [
            AutomationCodes.DETECTIVE_CLUB,
            AutomationCodes.SIMILO
        ];

        return this.gameState.tasks.state.type === TasksStateTypesEnums.STATE_PRESET_TYPE
            && this.gameState.tasks.state.show_play_again_button
            && !!this.currentGame
            && !!this.currentGame.automation_code
            && automationCodes.includes(this.currentGame.automation_code);
    }

    /**
     * Скрыть лоадер
     */
    private hideLoader(): void
    {
        this.loading = false;
        console.log("hiding loader VUE", this.loading, Date.now());
    }

    /**
     * Показать лоадер
     */
    private showLoader(): void
    {
        this.loading = true;
        console.log("showing loader VUE", this.loading, Date.now());
    }

    /**
     * Показать подготовленные задания
     */
    private startNextTask(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        const data = {
            contentPackId: this.gameState.tasks.state.content_pack_id,
            setId: this.gameState.tasks.state.set_id
        };
        MessageHelper.getContentPackTasksMessage(data);
    }

    /**
     * Сыргать еще раз
     */
    private playAgain(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        const data = {
            contentPackId: this.gameState.tasks.state.content_pack_id,
            setId: 1,
            activityId: this.gameState.tasks.state.activity_id,
            playAgain: true,
        };
        MessageHelper.getContentPackTasksMessage(data);
    }

    /**
     * Задизайблить эл-ты интерфейса, чтоб они не перехватывали события мыши стола
     */
    private disableLayoutInteractions(): void
    {
        this.mouseEventsAreAllowed = false;
    }

    /**
     * Включить события на эл-тах интерфейса
     */
    private enableLayoutInteractions(): void
    {
        this.mouseEventsAreAllowed = true;
    }

    /**
     * Загрузить сукно
     * @private
     */
    private uploadBackground(): void
    {
        const input = this.$refs.backgroundInput as HTMLInputElement;
        if (input.files && input.files[0]) {
            let formData = new FormData();
            formData.append('background', input.files[0]);

            UploadHelper.uploadFieldBackgroundRequest(formData, this.uploadBackgroundUrl)
                .then((result: UploadFieldBackgroundResponse) => {
                    if (result.success && result.background) {
                        MessageHelper.sendChangeFieldMessage(MessageHelper.TYPE_CHANGE_FIELD_BACKGROUND, {
                            background: result.background,
                            width: result.width,
                            height: result.height,
                        });
                    } else {
                        alert('Ошибка загрузки сукна');
                    }
                }).catch(() => {
                alert('Ошибка загрузки файлов');
            });
        }
    }

    /**
     * Увелить зум
     * @private
     */
    private zoomUp(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'zoomOut'});
        this.currentTableZoomValue += 0.05;
        const maxTableZoomValue = 1.25;
        if (this.currentTableZoomValue > maxTableZoomValue) {
            this.currentTableZoomValue = maxTableZoomValue
        }
        //Убрать после рефактора сцены
        PixiScene.getInstance()?.tableChangeZoom('+');

        this.newPixiScene?.zoom('+');
    }

    /**
     * Уменьшить зум
     * @private
     */
    private zoomDown(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'zoomIn'});

        this.currentTableZoomValue -= 0.05;
        let minTableZoomValue = 1;
        if (this.currentTableZoomValue < minTableZoomValue) {
            this.currentTableZoomValue = minTableZoomValue
        }
        //Убрать после рефактора сцены
        PixiScene.getInstance()?.tableChangeZoom('-');
        this.newPixiScene?.zoom('-');
    }

    /**
     * Сбросить зум
     * @private
     */
    private resetZoom(): void
    {
        if (this.currentTableZoomValue > (this.startTableZoomValue || 1)) {
            EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'zoomIn'});
        } else {
            EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'zoomOut'});
        }
        this.currentTableZoomValue = this.startTableZoomValue || 1;

        //Убрать после рефактора сцены
        PixiScene.getInstance()?.tableChangeZoom('*');

        this.newPixiScene?.zoom('*');
    }

    private hideTaskForm(): void
    {
        this.$emit('hideTaskForm');
        this.files = null;
        this.showTableForm = false;
        this.uploadFormType = '';
    }

    private addCardsOnDrag(e: any): void
    {
        if (e.dataTransfer.files) {
            e.preventDefault();
            this.files = e.dataTransfer.files;
            this.showTableForm = true;
        }
    }

    /**
     * Сохранить масштаб
     * @private
     */
    private saveScale(): void
    {
        //Убрать this.pixiScene === 'undefined' после рефактора сцены
        if(!this.newPixiScene && !this.pixiScene){
            return;
        }
        //Убрать this.pixiScene.getTableCameraParams() после рефактора сцены
        const cameraSetup = this.newPixiScene ? this.newPixiScene.tableCameraParams : this.pixiScene?.getTableCameraParams();

        MessageHelper.sendChangeFieldMessage(MessageHelper.TYPE_CHANGE_SCALE, {
            scale: {x: cameraSetup.scale, y: cameraSetup.scale},
            x: cameraSetup.x,
            y: cameraSetup.y,
            width:  cameraSetup.width,
            height: cameraSetup.height,
        });
    }

    /**
     * Обновить стол
     * @private
     */
    private refreshTable(): void
    {
        MessageHelper.sendChangeFieldMessage(MessageHelper.TYPE_REFRESH_TABLE, {});
    }

    /**
     * Изменить тип фона
     * @private
     */
    private changeBackgroundType(): void
    {
        MessageHelper.sendChangeFieldMessage(MessageHelper.TYPE_CHANGE_PATTERN, {
            pattern: this.isBackgroundPattern ? this.patternType : null,
        });
    }

    /**
     * Показать\скрыть лого
     * @private
     */
    private changeShowLogoState(): void
    {
        MessageHelper.sendChangeFieldMessage(MessageHelper.TYPE_CHANGE_SHOW_LOGO_STATE, {
            showLogo: !this.showLogo,
        });
    }

    /**
     * Вывести отладочную сетку в админке
     * @private
     */
    private changeAdminGridVisibility(): void
    {
        this.pixiScene?.tableContainer.changeAdminDebugVisibility(this.isAdminGridVisible);
        this.newPixiScene?.changeAdminDebugVisibility(this.isAdminGridVisible);
    }

    /**
     * Изменить тип паттерна
     * @param patternType
     * @private
     */
    private changePattern(patternType: number): void
    {
        this.patternType = patternType;
        MessageHelper.sendChangeFieldMessage(MessageHelper.TYPE_CHANGE_PATTERN, {
            pattern: patternType,
        });
    }

    /**
     * Создать объект переводов для стлоа и руки
     */
    private buildTranslations(): {[key: string]: string}
    {
        return {
            // @ts-ignore
            empty_hand: this.$t('hand.empty_hand')
        }
    }

    /**
     * Создать стол
     * @private
     */
    private createPixiTable(): void
    {
        const taskContainer = document.getElementById('gameTaskContainer') as HTMLElement;
        const tableContainer = this.$refs.tableStageNew as HTMLElement;
        let rect = this.isProfileEditor ? tableContainer.getBoundingClientRect() : taskContainer.getBoundingClientRect();

        let params = new URLSearchParams(document.location.search);
        console.log("OLD_SCENE" + params.get('oldScene'));

        //Исправить ниже после рефактора сцены
        if (params.get("oldScene")) {
            this.pixiScene = window.PixiScene = PixiScene.getInstance(rect, this.isProfileEditor, this.buildTranslations());
        } else {
            this.newPixiScene = window.PixiScene = NewPixiScene.createInstance(
                rect,
                this.isProfileEditor,
                this.buildTranslations(),
                this.playerId,
                this.players,
            );
        }

        if (this.isProfileEditor) {
            this.pixiScene?.toggleHand(false);
            this.newPixiScene?.toggleHand(false);
        }

        //Убрать после рефактора сцены
        if (!PixiScene.testMode && typeof tableContainer !== 'undefined' && this.pixiScene) {
            tableContainer.append(this.pixiScene?.view as HTMLCanvasElement);
        }

        if (!PixiScene.testMode && typeof tableContainer !== 'undefined' && this.newPixiScene) {
            tableContainer.append(this.newPixiScene?.view as HTMLCanvasElement);
        }
    }

    private dropImage(e: any): void
    {
        //Исправить ниже после рефактора сцены
        if ((!this.newPixiScene && !this.pixiScene)  || !this.isActive) {
            e.preventDefault();
            return;
        }

        if(this.pixiScene){
            this.uploadFormType = this.pixiScene.getDropZone(e.y);
        }
        if(this.newPixiScene){
            this.uploadFormType = this.newPixiScene.getDropZone(e.y);
        }
        this.addCardsOnDrag(e);
    }

    private showForm(type: string): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.uploadFormType = type;
        this.showTableForm = true;
    }

    private changeHandVisibilityWithMessage(e?: any): void {
        //Исправить ниже после рефактора сцены
        if (e.detail !== 'undefined' && this.pixiScene) {
            this.handIsOpened = e.detail;
            this.pixiScene.toggleHand(this.handIsOpened);
        }
        if (e.detail !== 'undefined' && this.newPixiScene) {
            this.handIsOpened = e.detail;
            this.newPixiScene.toggleHand(this.handIsOpened);
        }
    }

    /**
     * Скрыть/закрыть руку
     * @private
     */
    private toggleHandVisibility(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.handIsOpened = !this.handIsOpened;
        if (typeof (this.$refs.handBtn as HTMLElement) !== 'undefined') {
            (this.$refs.handBtn as HTMLElement).blur();
        }
        if (this.pixiScene) {
            this.pixiScene.toggleHand(this.handIsOpened);
        }
        this.newPixiScene?.toggleHand(this.handIsOpened);
        MessageHelper.toggleHandVisibility({visible: this.handIsOpened});
    }

    /**
     * Открыть доступный список автоматизаций
     * @private
     */
    private openAutomations(): void
    {
        this.automationsAreVisible = true;
        EventApi.triggerEvent(EventApi.SHOW_AUTOMATIONS);
    }

    /**
     * Скрыть доступный список автоматизаций
     * @private
     */
    private closeAutomations(): void
    {
        this.automationsAreVisible = false;
        EventApi.triggerEvent(EventApi.HIDE_AUTOMATIONS);
    }

    /**
     * Показать/скрыть дайсомет
     * @private
     */
    private toggleDiceGenerator(coordinates: {x: number, y: number}): void
    {
        // this.closeAllTools();
        this.diceGeneratorIsVisible = !this.diceGeneratorIsVisible;
        this.diceCoordinates = coordinates;
    }

    /**
     * Показать/скрыть заметки
     * @private
     */
    private toggleNotes(coordinates: {x: number, y: number}): void
    {
        // this.closeAllTools();
        this.noteIsVisible = !this.noteIsVisible;
        this.noteCoordinates = coordinates;
    }

    /**
     * Показать/скрыть таймер
     * @private
     */
    private toggleTimer(coordinates: {x: number, y: number}): void
    {
        // this.closeAllTools();
        this.timerIsVisible = !this.timerIsVisible;
        this.timerCoordinates = coordinates;
    }

    /**
     * скрыть дайсомет
     * @private
     */
    private closeDiceGenerator(): void
    {
        this.diceGeneratorIsVisible = false;
    }

    /**
     * скрыть таймер
     * @private
     */
    private closeTimer(): void
    {
        this.timerIsVisible = false;
    }

    /**
     * скрыть заметки
     * @private
     */
    private closeNote(): void
    {
        this.noteIsVisible = false;
    }

    /**
     * Скрыть все панели
     * @private
     */
    private closeAllTools(): void
    {
        this.diceGeneratorIsVisible = false;
        this.timerIsVisible = false;
        this.noteIsVisible = false;
    }
}
